import React from 'react';
import { Chip, Grid, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import { BudgetControlAreaSummary } from './budgetconsolidation.models';

const money = (value: any) => Number(value || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 });

type Props = { rows: BudgetControlAreaSummary[] };

export default class BudgetControlSummaryPanel extends React.PureComponent<Props> {
  render() {
    return (
      <Grid container spacing={2}>
        {(this.props.rows || []).map(row => (
          <Grid key={row.controlareacode} size={{ xs: 12, md: 4 }}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                    {row.controlareaname || row.controlareacode}
                  </Typography>
                  <Chip size="small" label={row.controlstatus || 'AVAILABLE'} />
                </Stack>
                <Typography variant="body2">Ceiling: <strong>{money(row.ceilingamount)}</strong></Typography>
                <Typography variant="body2">Consolidated: <strong>{money(row.requestedamount)}</strong></Typography>
                <Typography variant="body2">Available: <strong>{money(row.availableamount)}</strong></Typography>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(0, Math.min(100, Number(row.utilisationpercent || 0)))}
                />
                <Typography variant="caption" color="text.secondary">
                  {Number(row.utilisationpercent || 0).toFixed(1)}% utilised
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        ))}
      </Grid>
    );
  }
}
